import scrollTargetPath from './scroll-target-path';

export default {
  scrollTargetPath,
};
